import api from "api/flexapi";

export const FETCH_CLAIM_ACCOUNTS_BEGIN = "FETCH_CLAIM_ACCOUNTS_BEGIN";
export const FETCH_CLAIM_ACCOUNTS_SUCCESS = "FETCH_CLAIM_ACCOUNTS_SUCCESS";
export const FETCH_CLAIM_ACCOUNTS_ERROR = "FETCH_CLAIM_ACCOUNTS_ERROR";

export const FETCH_CLAIM_BENEFIT_PLANS_BEGIN = "FETCH_CLAIM_BENEFIT_PLANS_BEGIN";
export const FETCH_CLAIM_BENEFIT_PLANS_SUCCESS = "FETCH_CLAIM_BENEFIT_PLANS_SUCCESS";
export const FETCH_CLAIM_BENEFIT_PLANS_ERROR = "FETCH_CLAIM_BENEFIT_PLANS_ERROR";

export const fetchClaimAccounts = (effectiveDate, selectedDelegator) => dispatch => {
  const data = {
    effectiveDate,
    selectedDelegator,
  };
  dispatch({ type: FETCH_CLAIM_ACCOUNTS_BEGIN });
  api
    .getSpendingAccounts(data)
    .then(response =>
      dispatch({
        type: FETCH_CLAIM_ACCOUNTS_SUCCESS,
        payload: response.body,
      })
    )
    .catch(err =>
      dispatch({
        type: FETCH_CLAIM_ACCOUNTS_ERROR,
        payload: err.response ? err.response.body : err,
      })
    );
};

export const fetchNewSpendingAccounts = (effectiveDate, selectedDelegator) => dispatch => {
  const data = {
    effectiveDate,
    selectedDelegator,
  };
  dispatch({ type: FETCH_CLAIM_ACCOUNTS_BEGIN });
  api
    .getNewSpendingAccounts(data)
    .then(response =>
      dispatch({
        type: FETCH_CLAIM_ACCOUNTS_SUCCESS,
        payload: response.body,
      })
    )
    .catch(err =>
      dispatch({
        type: FETCH_CLAIM_ACCOUNTS_ERROR,
        payload: err.response ? err.response.body : err,
      })
    );
};

export const fetchClaimBenefitPlans = () => dispatch => {
  dispatch({ type: FETCH_CLAIM_BENEFIT_PLANS_BEGIN, payload: null });
  api
    .getBenefitPlans()
    .then(response => {
      dispatch({
        type: FETCH_CLAIM_BENEFIT_PLANS_SUCCESS,
        payload: response.body,
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_CLAIM_BENEFIT_PLANS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./actions/claimAccountsActions.js